import React from 'react';

export default function Attactment({file}) {
    return (
        <span className="attachment-download">
            {file && file.url ? <a href={file.url}>{file.fileName}</a> : '-'}
        </span>
    )
}
